import Text from '~/common/components/Texts/Text';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';
import { pixelsToRem } from '~/theme/typography';

import BreakdownContainer from '../BreakdownContainer';
import lang from '../language.json';
import BreakdownColumnBox from '../styles/BreakdownColumnBox';
import SingleLineValue from '../styles/SingleLineValue';
import Continuance from './Continuance';

type IRA1099BreakdownProps = {
  selectedResult: CalculationResult;
  onNewWindow?: (...args: any[]) => any;
  hideAccordion?: boolean;
};

export default function IRA1099Breakdown({
  selectedResult,
  hideAccordion = false,
  onNewWindow,
}: Readonly<IRA1099BreakdownProps>) {
  const formulas = selectedResult.formulas.filter(
    (formula) => !formula.formulaName.includes('Continuance'),
  );

  return (
    <BreakdownContainer
      header={lang.HEADERS[selectedResult.calculatorTypeId]}
      hideAccordion={hideAccordion}
      onNewWindow={onNewWindow}
    >
      <SingleLineValue
        title={lang.MONTHLY_CALC_EQUATION}
        value={lang.FORMULAS.IRA_1099}
      />
      {formulas.length > 0 && (
        <BreakdownColumnBox title={lang.CALCULATION} mb={4}>
          {formulas.map(({ formulaId, formula }) => (
            <Text fontSize={pixelsToRem(14)} key={formulaId}>
              {formula}
            </Text>
          ))}
        </BreakdownColumnBox>
      )}
      <SingleLineValue
        title={lang.MONTHLY_INCOME}
        value={selectedResult.calculationAmount}
        isCurrency
      />
      <Continuance selectedResult={selectedResult} />
    </BreakdownContainer>
  );
}
